<template id="form_section">
  <div class="franchise-wrapper">
    <!-- New Design -->
    <FranchiseCommanDataVue
      OfficeName="Mira Road"
      OfficeNameAlternateLang="मीरा रोड कार्यालयात आपले स्वागत आहे"
      OfficeAddress="C-78, Shanti Shopping Centre, Near Mira Road Station, Mira Road (E),
            Thane 401107"
      OfficeEmail="preeti@aliff.in"
      OfficePhone="+91 8356991403"
      :source="27"
    />

    <section class="founder-section pb-xl-5 mb-5">
      <!-- background_image_section -->

      <div class="container-fluid responsive_padding">
        <h2
          class="main-heading-1-gradient text-center"
          data-aos="fade-down"
          data-aos-duration="600"
        >
          About Area Director
        </h2>

        <div class="row mt-5 align-items-start custom_director_section">
          <div
            class="col-md-4 col-lg-4 responsive-img text-center"
            data-aos="fade-right"
            data-aos-duration="600"
          >
            <!-- <img
              src="@/assets/imgs/aslam-founder.png"
              class="img-fluid border-20 custom_width_image"
            /> -->
            <img
              src="@/assets/imgs/franchise/1.png"
              class="img-fluid border-20 custom_width_image desktop_img_width"
            />
          </div>
          <div
            class="col-md-8 col-lg-8 text-left"
            data-aos="fade-left"
            data-aos-duration="600"
          >
            <h1 class="font-weight-bold responsive_margin_area"
              >Preeti Ganju</h1
            >

            <div class="row">
              <div class="col-md-6">
                <h5 class="new_sub_heading_color pt-2 font-weight-bold"
                  >Background</h5
                >
                <p class="main-content-1 pt-2 custom_font_sizing">
                  Student Mentor - Overseas Education for Ambitious Students.
                </p>
              </div>

              <div class="col-md-6">
                <h5 class="new_sub_heading_color pt-2 font-weight-bold"
                  >Education</h5
                >
                <p class="main-content-1 pt-2 custom_font_sizing">
                  Graduate from ML Dahanukar College, Mumbai.
                </p>
              </div>

              <div class="col-md-12">
                <h5 class="new_sub_heading_color pt-2 font-weight-bold"
                  >Professional Experience</h5
                >
                <p class="main-content-1 pt-2 custom_font_sizing">
                  Incredibly fulfilling experience to help the young generation
                  in building their future. I stay updated about the latest
                  trends, programs, and opportunities in study abroad. Offer
                  personalized counseling sessions to understand students’
                  aspirations and provide tailored advice accordingly. This
                  helps me to recognize that each student is unique with
                  different goals, preferences, and challenges. Offer guidance
                  on budgeting and financial planning to ensure a smooth
                  transition. Provide comprehensive pre-departure orientation
                  sessions covering practical aspects such as visa procedures,
                  accommodation options, healthcare provisions, and safety tips.
                  Addressing any concerns or anxieties beforehand can ease the
                  transition for students.
                </p>
              </div>

              <div class="col-md-6">
                <h5 class="new_sub_heading_color pt-2 font-weight-bold"
                  >Travel Experience</h5
                >
                <p class="main-content-1 pt-2 custom_font_sizing">
                  By incorporating my travel experiences into study abroad
                  programs, as an educator can create transformative learning
                  opportunities that broaden students' horizons, foster cultural
                  awareness, and inspire lifelong curiosity and exploration.
                </p>
              </div>

              <div class="col-md-6">
                <h5 class="new_sub_heading_color pt-2 font-weight-bold"
                  >Membership</h5
                >
                <p class="main-content-1 pt-2 custom_font_sizing">
                  Affiliations with 1 micro-franchise, 2 associates and WIP with
                  3 colleges.
                </p>
              </div>
              <!-- <h5 class="new_sub_heading_color pt-2 font-weight-bold"
              >Current Affairs</h5
            >
            <p class="main-content-1 pt-2"> Travel agency- Krishna Holidays </p> -->
              <!--
              <div class="col-md-6">
                <h5 class="new_sub_heading_color pt-2 font-weight-bold"
                  >Location</h5
                >
                <p class="main-content-1 pt-2"> Hubali, Karnataka , India </p>
              </div> -->
            </div>
            <!-- <img
              src="@/assets/imgs/franchise/Group18259.png"
              class="director_background"
            /> -->
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid pb-xl-5 responsive_padding">
      <h2
        class="main-heading-1-gradient text-center mb-5"
        data-aos="fade-down"
        data-aos-duration="600"
      >
        Our Office Images
      </h2>
      <div class="team-member-cards">
        <slick
          ref="teamIntroSlider"
          :options="teamIntroSlider"
          class="stu-card-slider green-slick-dots franchise-card-slider text-center"
        >
          <img
            src="@/assets/imgs/franchise/MiraRoad/MiraRoad1.jpeg"
            class="custom_slider_img_height"
            style="object-position: top"
          />
          <img
            src="@/assets/imgs/franchise/MiraRoad/MiraRoad2.jpeg"
            class="custom_slider_img_height"
            style="object-position: top"
          />
        </slick>
      </div>
    </section>

    <hr
      class="horizontal_line py-xl-1 mb-5"
      data-aos="fade-down"
      data-aos-duration="600"
    />

    <section class="container">
      <div class="row">
        <div class="col-12 mb-5">
          <!-- <div class="d-flex align-items-center justify-content-center">
            <img
              title="my-img"
              src="@/assets/imgs/student-enquiry-form/AliffLogo.png"
              alt="people"
              class="free-counselling-logo-new"
            />
            <h2>Book Free Counselling</h2>
          </div>
          <p>
            Go doubt-free in your study abroad journey by connecting with our
            experts!
          </p>
          <div class="mt-3">Schedule a free call and get:</div>
          <ul>
            <li>Your profile evaluated.</li>
            <li>Country, university and course guidance.</li>
            <li>Scholarship and loan assistance.</li>
          </ul>
          <a href="#form_section" class="w-100 text-center">
            <button class="btn-secondary-red mt-4 w-100">
              Schedule Call
            </button>
          </a> -->
          <div class="w-100 d-flex justify-content-center">
            <a href="#form_section" class="w-50 text-center">
              <button class="main_btn_custom"
                >Book Your Free Counseling Today</button
              >
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import {
    stateOptions,
    courseOptions,
    specializationOptions,
    cityOptions,
  } from "../partials/sefDetails";
  import FranchiseCommanDataVue from "../partials/FranchiseCommanData.vue";
  export default {
    components: {
      FranchiseCommanDataVue,
    },
    data() {
      return {
        establishedvalue: 2008,
        studentValue: 23,
        featured_universities: [],
        logoSlider: {
          infinite: true,
          slidesToShow: 6,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 1000,
          speed: 3000,
          pauseOnHover: true,
          cssEase: "linear",
          centerMode: true,
          centerPadding: "30px",
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ],
        },
        teamIntroSlider: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: false,
          autoplay: true,
          autoplaySpeed: 0,
          speed: 5000,
          // cssEase: "linear",
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        },

        stateOptions,
        courseOptions,
        specializationOptions,
        cityOptions,
        form: {
          name: "",
          email: "",
          mobileNumber: "",
          state: null,
          city: null,
        },
        destinationSlider: {
          infinite: true,
          rows: 2,
          slidesPerRow: 1,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 1000,
          cssEase: "ease",
          useTransform: true,
          speed: 1000,
          cssEase: "linear",
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
              },
            },
          ],
        },
      };
    },

    methods: {},
  };
</script>
<style>
  .franchise-wrapper {
    margin-top: 120px;
  }
  .form_wrapper {
    padding: 20px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
  .fontWeightCustom {
    font-weight: 500;
  }
  .horizontal_line {
    width: 100%;
  }
  .city_img {
    position: absolute;
    top: 190px;
    right: 20px;
    z-index: -1;
    opacity: 0.2;
  }
  .city_img img {
    width: 90%;
  }
  .numbers_class {
    font-size: 30px;
    font-weight: bold;
  }
  .sub_heading_text {
    font-size: 30px;
  }
  .icons_custom {
    width: 25%;
    filter: drop-shadow(0 0 0.75rem black);
    margin-bottom: 10px;
  }
  .director_background {
    position: absolute;
    right: 0;
    top: 100px;
    opacity: 0.2;
    z-index: -1;
  }
  .custom_director_section {
    padding: 40px;
    background: #eaf4fe;
    border-radius: 10px;
    box-shadow: 0px 0px 0.806476px rgba(12, 26, 75, 0.1),
      3.22591px 4.83886px 12.9036px rgba(20, 37, 63, 0.12);
  }
  .responsive_padding {
    padding: 0 3rem;
  }
  .new_sub_heading_color {
    color: #ff3d00 !important;
  }
  .mob_hr {
    display: none;
  }
  @media (max-width: 767px) {
    .responsive_margin {
      margin-top: 20px;
    }
    .responsive_margin_area {
      margin-top: 30px;
    }
    .main_btn_custom {
      width: 100%;
      transform: scale(1) !important;
    }
    .director_background {
      position: absolute;
      top: 15px;
      opacity: 0.1;
      z-index: -1;
      widows: 100%;
      right: -133px;
    }
    .responsive_padding {
      padding: 0px;
    }
    .custom_overflow {
      overflow: hidden;
    }
    .city_img {
      position: absolute;
      top: 44%;
      right: -30%;
      z-index: -1;
      opacity: 0.2;
      /* width: 100%; */
    }
    .mob_hr {
      display: block;
    }
    .mob_custom_padding {
      padding-bottom: 10px !important;
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .custom_overflow {
      overflow: hidden;
    }
    .responsive_margin {
      margin-top: 10px;
    }
    .city_img {
      position: absolute;
      top: -15%;
      right: -30%;
      opacity: 0.2;
      width: 100%;
    }
    .director_background {
      position: absolute;
      right: 0;
      top: 0px;
      opacity: 0.1;
    }
    .icons_custom {
      width: 40%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/MiraRoadFranchisePage.vue